import React, { useCallback, useState } from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { ImportFromCityPortal } from './components/ImportFromCityPortal/ImportFromCityPortal';
import useCompanies from '../../queries/useCompanies';

const MassActionTypes = {
  importFromCityPortal: 'importFromCityPortal',
};

export const RequestsMassActions = () => {
  const [visible, setVisible] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const resetSelectedAction = useCallback(() => setSelectedAction(null), []);
  const handleSuccessImport = useCallback(() => {
    resetSelectedAction();
    setVisible(false);
  }, [resetSelectedAction]);

  const companiesQuery = useCompanies();
  const canImportFromCityPortal = companiesQuery?.data?.some((company) => {
    return company.id === 673 || company.name === 'ЖКС № 1 Приморского района';
  });

  const availableMassActions = [];
  if (canImportFromCityPortal) {
    availableMassActions.push({
      key: 'importFromCityPortal',
      text: 'Загрузить заявки с городского портала',
      onClick: () => {
        setSelectedAction(MassActionTypes.importFromCityPortal);
      },
    });
  }

  if (!availableMassActions.length) {
    return null;
  }

  return (
    <>
      <Tooltip
        title="Массовая загрузка"
        placement="bottom"
      >
        <Button
          type="primary"
          shape="circle"
          icon="upload"
          style={{ marginRight: '10px' }}
          onClick={() => {
            setVisible(true);
          }}
        />
      </Tooltip>

      <Modal
        visible={visible}
        title="Выберите тип загрузки"
        onCancel={() => setVisible(false)}
        afterClose={resetSelectedAction}
        footer={null}
      >
        {availableMassActions.map((action) => (
          <div
            key={action.key}
            style={{ textAlign: 'center' }}
          >
            <Button onClick={action.onClick}>{action.text}</Button>
          </div>
        ))}
      </Modal>

      <ImportFromCityPortal
        visible={selectedAction === MassActionTypes.importFromCityPortal}
        onCancel={resetSelectedAction}
        onSuccess={handleSuccessImport}
      />
    </>
  );
};
